import { CollectionType } from "containers/folders/types/assortment";
import { IBrand } from "containers/folders/types/brands";

type GetDefaultSelectedBrandIdProps = {
    canShopBrand: boolean;
    isVerticalAssortmentEnabled: boolean;
    canShopBrandOnProductCollectionContext: boolean;
    collectionDriveItem: nuorder.folder.v1.Item;
};

export const getDefaultSelectedBrandId = ({
    canShopBrand,
    canShopBrandOnProductCollectionContext,
    isVerticalAssortmentEnabled,
    collectionDriveItem,
}: GetDefaultSelectedBrandIdProps) => {
    if (canShopBrand !== undefined) {
        return canShopBrand ? collectionDriveItem.collection_facet.brand_portal_id : null;
    }

    if (isVerticalAssortmentEnabled || canShopBrandOnProductCollectionContext) {
        return collectionDriveItem.collection_facet.brand_portal_id;
    }

    return null;
};

type GetDefaultAssortmentTypeProps = {
    isVerticalAssortmentEnabled: boolean;
    isCloseoutBrandAssortment: boolean;
    hasBrandPortalId: boolean;
};

export const getDefaultAssortmentType = ({
    isVerticalAssortmentEnabled,
    isCloseoutBrandAssortment,
    hasBrandPortalId,
}: GetDefaultAssortmentTypeProps) => {
    if (isVerticalAssortmentEnabled) {
        return CollectionType.Vertical;
    }

    if (isCloseoutBrandAssortment) {
        return CollectionType.BrandStandard;
    }

    if (hasBrandPortalId) {
        return CollectionType.External;
    }

    return CollectionType.Internal;
};

export const validateMerchantBrandMatch = (merchantId: string, brand: IBrand) => {
    return brand?.merchant_id === merchantId ? brand : undefined;
};
